// Per-race/tech FX colors. Resolution order: unit.fx → unit.nation.fx → defaults.
// Both the units and nations collections may carry an `fx` object like
// { shield: '#26aeff', weapon: '#ff3322', engine: '#66ccff' } — values are
// hex strings or numbers. Nation fx is projected to the client in
// providers/map.js and server/movements.js getNation().
export const DEFAULT_FX = {
	shield: 0x26aeff,
	weapon: 0x6666ff,
	engine: 0x66ccff,
};

function toColorNumber(value) {
	if (typeof value === 'number' && Number.isFinite(value)) return value;
	if (typeof value === 'string' && value) {
		const parsed = Number(value.replace('#', '0x'));
		if (!Number.isNaN(parsed)) return parsed;
	}
	return null;
}

export function getUnitFx(unit) {
	const own = unit?.fx || {};
	const nation = unit?.nation?.fx || {};
	const fx = {};
	for (const key of Object.keys(DEFAULT_FX)) {
		fx[key] = toColorNumber(own[key]) ?? toColorNumber(nation[key]) ?? DEFAULT_FX[key];
	}
	return fx;
}
